import { Button } from "components/Button";
import { DashProgressBar } from "components/DashProgressBar";
import type { PathParams } from "models/path/Path";
import type React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import type { AdditionalsTestRowProps } from "./AdditionalsTestRow.model";
import {
  StyleBarContainer,
  StyleContainer,
  StyleParagraph,
  StylePercentage,
  StyleProgressContainer,
  StyleSubContainer,
  StyleTitle,
} from "./AdditionalsTestRow.styled";

export const AdditionalsTestRow: React.FC<AdditionalsTestRowProps> = ({
  chapter,
  index,
  result,
}) => {
  const { t } = useTranslation("material");
  const { additionalsId }: PathParams = useParams();
  return (
    <StyleContainer data-cy="additionals-test-row">
      <div>
        <StyleParagraph>{t("additionals.testResults", "Test results")}</StyleParagraph>
        <StyleTitle>
          {`${t("additionals.chapter", "Chapter")} ${+index + 1} - ${chapter.title}`}
        </StyleTitle>
      </div>
      <StyleSubContainer>
        <div>
          <StyleProgressContainer>
            <StyleBarContainer>
              <DashProgressBar progress={result} />
            </StyleBarContainer>
            <StylePercentage>{result}%</StylePercentage>
          </StyleProgressContainer>
        </div>
        <Link to={`/${additionalsId}/test/${chapter.id}`}>
          <Button
            dataCy="go-test-button"
            height={40}
            itemId={`chapter-${chapter.id}-button`}
            module="overview-chapter-list"
            variant="blank"
            width={80}
          >
            {t("additionals.startButton", "Start")}
          </Button>
        </Link>
      </StyleSubContainer>
    </StyleContainer>
  );
};
